<template>
  <section id="projects" class="projects">
    <div class="background" />
    <div class="header-box">
        <h2>Unsere Projekte</h2>
    </div>
      <div class="slider">
        <b-carousel
            id="carousel-1"
            v-model="slide"
            :interval="4000"
            controls
            indicators
            background="#d4e9d8"
            img-width="1024"
            img-height="480"
            style="text-shadow: 1px 1px 2px #333;"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
        >
          <!-- Text slides with image -->
          <b-carousel-slide img-src="../../assets/images/projects/teich.jpeg" />
          <b-carousel-slide img-src="../../assets/images/projects/garten.jpeg" />
        </b-carousel>
      </div>
  </section>
</template>

<script>
  export default {
    name: 'Projects',
    data() {
      return {
        slide: 0,
        sliding: null
      }
    },
    methods: {
      onSlideStart() {
        this.sliding = true
      },
      onSlideEnd() {
        this.sliding = false
      }
    }
  }
</script>

<style lang="scss">
  @import '../../assets/styles/home/projects.scss';
</style>
